/**
 * Route for `scheduled-email-report-daily-weekly-monthly`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ScheduledEmailReportDailyWeeklyMonthlyPage } from "../features/scheduled-email-report-daily-weekly-monthly/ScheduledEmailReportDailyWeeklyMonthlyPage";

export const scheduledEmailReportDailyWeeklyMonthlyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/scheduled-email-report-daily-weekly-monthly",
	component: ScheduledEmailReportDailyWeeklyMonthlyPage,
});

export default scheduledEmailReportDailyWeeklyMonthlyRoute;
